import { Badge } from 'react-bootstrap';
import { BsExclamationTriangle } from 'react-icons/bs';

import { css } from '@emotion/css';

export const NewBadge = () => {
	return (
		<Badge variant="primary" className="badge">
			new
		</Badge>
	);
};

export const DeletedBadge = () => {
	return (
		<Badge variant="danger" className="badge">
			deleted
		</Badge>
	);
};

export const ModifiedBadge = () => {
	return (
		<Badge variant="info" className="badge">
			modified
		</Badge>
	);
};

export const WarningBadge = () => {
	return (
		<Badge variant="warning">
			warning <BsExclamationTriangle />
		</Badge>
	);
};

export const GeneratingQuestionsBadge = () => {
	return (
		<Badge variant="info">
			<div>
				generating questions <span className={loaderStyles}>...</span>
			</div>
		</Badge>
	);
};

export const FeedbackNeededBadge = () => {
	return (
		<Badge variant="info">
			<div>question generation feedback needed</div>
		</Badge>
	);
};

const loaderStyles = css`
	font-family: monospace;
	clip-path: inset(0 3ch 0 0);
	animation: l1 2s steps(4) infinite;

	@keyframes l1 {
		to {
			clip-path: inset(0 -1ch 0 0);
		}
	}
`;
